import styled from "styled-components";

export const AreaForm = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const ContainerVehicles = styled.div`
	background: #fff;
	padding: 12px;
	border-radius: 10px;

	p {
		margin: 0;
	}
`;

export const ListVehicles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 10px;

	p {
		margin: 0;
	}
`;

export const FooterButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: 1rem 0 0 0;

	> button {
		max-width: 200px;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		& > button {
			margin: 0 0 1rem 0;
			width: 100%;
			max-width: 100%;
		}
	}
`;
